'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isInvisible = require('coact-utils/isInvisible');

var _isInvisible2 = _interopRequireDefault(_isInvisible);

var _Input = require('../../../inputs/Input');

var _Input2 = _interopRequireDefault(_Input);

var _isNil = require('coact-utils/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NumberCondition(props) {
  var linkState = props.linkState,
      style = props.style,
      value = props.value;
  var equal = value.equal,
      gte = value.gte,
      lte = value.lte;


  var useEqual = !(0, _isInvisible2.default)(equal);
  var useRange = !(0, _isInvisible2.default)(gte) || !(0, _isInvisible2.default)(lte);

  return _react2.default.createElement(
    'div',
    { className: style.searchWidget },
    _react2.default.createElement(
      'span',
      null,
      '\uFF1D'
    ),
    _react2.default.createElement(
      'div',
      { className: style['number-container'] },
      _react2.default.createElement(_Input2.default, _extends({
        type: 'number'
      }, linkState('equal'), {
        disabled: useRange
      }))
    ),
    _react2.default.createElement(
      'span',
      null,
      '\uFF0C'
    ),
    _react2.default.createElement(
      'div',
      { className: style['number-container'] },
      _react2.default.createElement(_Input2.default, _extends({
        type: 'number'
      }, linkState('gte'), {
        disabled: useEqual
      }))
    ),
    _react2.default.createElement(
      'span',
      null,
      '\uFF5E'
    ),
    _react2.default.createElement(
      'div',
      { className: style['number-container'] },
      _react2.default.createElement(_Input2.default, _extends({
        type: 'number'
      }, linkState('lte'), {
        disabled: useEqual
      }))
    )
  );
}
var func = _propTypes2.default.func,
    object = _propTypes2.default.object,
    shape = _propTypes2.default.shape,
    number = _propTypes2.default.number;

NumberCondition.propTypes = {
  value: shape({
    equal: number,
    gte: number,
    lte: number
  }).isRequired,
  linkState: func.isRequired,
  style: object.isRequired
};

NumberCondition.buildQuery = function buildNumberQuery(_ref) {
  var equal = _ref.equal,
      gte = _ref.gte,
      lte = _ref.lte;

  if ((0, _isNil2.default)(equal) && (0, _isNil2.default)(gte) && (0, _isNil2.default)(lte)) return null;

  var operation = {};
  if (!(0, _isInvisible2.default)(equal)) {
    operation.$eq = equal;
  } else {
    if (!(0, _isInvisible2.default)(gte)) {
      operation.$gte = gte;
    }
    if (!(0, _isInvisible2.default)(lte)) {
      operation.$lte = lte;
    }
  }

  return operation;
};

exports.default = NumberCondition;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/ConditionEditor/NumberCondition.js
// module id = 1745
// module chunks = 0